module.exports = __webpack_public_path__ + "static/img/invite11.47b4da08.png";